/**
 * Do not edit directly
 */

export const componentModalActionsAlignHorizontal = "flex-end";
export const componentModalActionsBorderColorTop = "#e3e4e5";
export const componentModalActionsBorderWidthTop = "0.0625rem";
export const componentModalActionsPaddingBS = "1rem";
export const componentModalActionsPaddingBM = "1.5rem";
export const componentModalCloseButtonAliasName = "component.overlay.closeButton";
export const componentModalContainerBackgroundColor = "#fff";
export const componentModalContainerBorderRadius = "1rem";
export const componentModalContainerElevation = "0 0.3125rem 0.625rem 0.1875rem rgba(0, 0, 0, 0.15), 0 -0.0625rem 0.25rem 0 rgba(0, 0, 0, 0.10)";
export const componentModalContainerSizeSmallMaxWidth = "25rem";
export const componentModalContainerSizeMediumMaxWidth = "37.5rem";
export const componentModalContainerSizeLargeMaxWidth = "50rem";
export const componentModalContainerStateEnterOpacity = 0; // TODO: figure this out
export const componentModalContainerStateEnterScale = 0; // TODO: figure this out
/**
 * @deprecated Transition shorthand property design token will be removed in a future version. Refer https://jira.walmart.com/browse/LD-3155.
 */
export const componentModalContainerStateEnterActiveTransition = "opacity 300 linear, transform 500 cubic-bezier(0.165, 0.84, 0.44, 1)";
export const componentModalContainerStateEnterActiveOpacityTransitionTransitionDuration = 300;
export const componentModalContainerStateEnterActiveOpacityTransitionTransitionProperty = "opacity";
export const componentModalContainerStateEnterActiveOpacityTransitionTransitionTimingFunction = "linear";
export const componentModalContainerStateEnterActiveTransformTransitionTransitionDuration = 500;
export const componentModalContainerStateEnterActiveTransformTransitionTransitionProperty = "transform";
export const componentModalContainerStateEnterActiveTransformTransitionTransitionTimingFunction = "cubic-bezier(0.165, 0.84, 0.44, 1)";
export const componentModalContainerStateEnterActiveOpacity = 1; // TODO: figure this out
export const componentModalContainerStateEnterActiveScale = 1; // TODO: figure this out
export const componentModalContainerStateExitOpacity = 1; // TODO: figure this out
export const componentModalContainerStateExitScale = 1; // TODO: figure this out
/**
 * @deprecated Transition shorthand property design token will be removed in a future version. Refer https://jira.walmart.com/browse/LD-3155.
 */
export const componentModalContainerStateExitActiveTransition = "opacity 500 linear";
export const componentModalContainerStateExitActiveTransitionDuration = 500;
export const componentModalContainerStateExitActiveTransitionProperty = "opacity";
export const componentModalContainerStateExitActiveTransitionTimingFunction = "linear";
export const componentModalContainerStateExitActiveOpacity = 0; // TODO: figure this out
export const componentModalContainerZIndex = "500";
export const componentModalContentPaddingBottomBS = "1rem";
export const componentModalContentPaddingBottomBM = "1.5rem";
export const componentModalContentPaddingHorizontalBS = "1rem";
export const componentModalContentPaddingHorizontalBM = "1.5rem";
export const componentModalHeaderAlignHorizontal = "space-between";
export const componentModalHeaderAlignVertical = "flex-start";
export const componentModalHeaderPaddingEndBS = "0.5rem";
export const componentModalHeaderPaddingEndBM = "1rem";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.modal.header.paddingStart.bS` instead.
 */
export const componentModalHeaderPaddingLeftBS = "1rem";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.modal.header.paddingStart.bM` instead.
 */
export const componentModalHeaderPaddingLeftBM = "1.5rem";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.modal.header.paddingEnd.bS` instead.
 */
export const componentModalHeaderPaddingRightBS = "0.5rem";
/**
 * @deprecated This token has been deprecated during https://jira.walmart.com/browse/LD-2583. Please use `component.modal.header.paddingEnd.bM` instead.
 */
export const componentModalHeaderPaddingRightBM = "1rem";
export const componentModalHeaderPaddingStartBS = "1rem";
export const componentModalHeaderPaddingStartBM = "1.5rem";
export const componentModalHeaderPaddingVerticalBS = "0.625rem";
export const componentModalHeaderPaddingVerticalBM = "1.375rem";
export const componentModalLayoutContainerAlignHorizontal = "center";
export const componentModalLayoutContainerAlignVertical = "center";
export const componentModalLayoutContainerHeight = "100%";
export const componentModalLayoutContainerPaddingBS = "1rem"; // TODO: figure this out
export const componentModalLayoutContainerPaddingBM = "2rem"; // TODO: figure this out
export const componentModalLayoutContainerPaddingBL = "4rem"; // TODO: figure this out
export const componentModalLayoutContainerWidth = "100%";
export const componentModalScrimBackgroundColor = "rgba(0, 0, 0, 0.4)";
export const componentModalScrimStateEnterOpacity = 0;
export const componentModalScrimStateEnterActiveOpacity = 1;
/**
 * @deprecated Transition shorthand property design token will be removed in a future version. Refer https://jira.walmart.com/browse/LD-3155.
 */
export const componentModalScrimStateEnterActiveTransition = "opacity 500 linear";
export const componentModalScrimStateEnterActiveTransitionDuration = 500;
export const componentModalScrimStateEnterActiveTransitionProperty = "opacity";
export const componentModalScrimStateEnterActiveTransitionTimingFunction = "linear";
export const componentModalScrimStateExitOpacity = 1;
export const componentModalScrimStateExitActiveOpacity = 0;
/**
 * @deprecated Transition shorthand property design token will be removed in a future version. Refer https://jira.walmart.com/browse/LD-3155.
 */
export const componentModalScrimStateExitActiveTransition = "opacity 500 linear";
export const componentModalScrimStateExitActiveTransitionDuration = 500;
export const componentModalScrimStateExitActiveTransitionProperty = "opacity";
export const componentModalScrimStateExitActiveTransitionTimingFunction = "linear";
export const componentModalTitleFontFamily = "Bogle, 'Helvetica Neue', Helvetica, Arial, sans-serif";
export const componentModalTitleFontSizeBS = "1.25rem";
export const componentModalTitleFontSizeBM = "1.5rem";
export const componentModalTitleFontWeight = 700;
export const componentModalTitleLineHeightBS = "1.75rem";
export const componentModalTitleLineHeightBM = "2.25rem";
export const componentModalTitleMarginTopBS = "0.375rem";
export const componentModalTitleMarginTopBM = "0.125rem";
export const componentModalTitleTextColor = "#2e2f32";